import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumb, BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import PreClearanceForm from '@app/components/apps/PreClearance/PreClearanceForm';
import { useHeader } from '@app/components/header/layouts/HeaderContext';

export const ViewPreClearancePage: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Loading...');

  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/pre-clearance',
      breadcrumbName: 'Pre-Clearance',
    },
    {
      path: '/view-pre-clearance',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <PreClearanceForm
            type={'view'}
            editable={false}
            id={id}
            pageTitle={`View PreClearance`}
            setCurrentBreadcrumName={setCurrentBreadcrumName}
          />
        </Col>
      </Row>
    </>
  );
};

export default ViewPreClearancePage;
